import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {durationValidator} from './duration-validator';

@Directive({
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: DurationDirective
        }
    ],
    selector: '[duration]'
})
export class DurationDirective {
    @Input() public maximum: any;
    @Input() public minimum: any;

    constructor() {
    }

    /**
     *
     * @param abstractControl
     */
    public validate(abstractControl: AbstractControl): { [key: string]: any } | null {
        return durationValidator(this.maximum, this.minimum)(abstractControl);
    }
}
